import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { adminApi } from "@/lib/api";

const AuthContext = createContext(null);

const loadMe = async () => {
  try {
    return (await adminApi.get("/auth/me")).data;
  } catch {
    await adminApi.post("/auth/refresh");
    return (await adminApi.get("/auth/me")).data;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    loadMe().then(setUser).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setUser(data);
  };

  const logout = async () => {
    await adminApi.post("/auth/logout");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="admin-loading">
        <Loader2 className="h-8 w-8 animate-spin text-acid" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
